import { addDays, differenceInDays, isAfter } from 'date-fns';

import { CREATE_DATES, SELECT_DATE } from '../actions/date_nav';

const createDates = (start = new Date(), create = 14) => {
  let i = 0;
  const dates = [];
  do {
    i += 1;
    dates.push(addDays(start, i));
  } while (i < create);

  return dates;
};

const initState = {
  date: new Date(),
  datesList: createDates(),
};

const createNewDates = (state, { days }) => {
  const { datesList } = state;
  const lastDate = datesList[datesList.length - 1];

  const newDates = createDates(lastDate, 7);

  return { ...state, datesList: datesList.concat(newDates) };
};

const selectDate = (state, { date }) => {
  const { datesList } = state;
  const lastDate = datesList[datesList.length - 1];
  if (isAfter(date, lastDate)) {
    const days = differenceInDays(date, lastDate) + 1;
    const newDates = createDates(lastDate, days);

    return { ...state, date, datesList: datesList.concat(newDates) };
  }

  return { ...state, date };
};

export default (state = {}, action) => {
  const newState = { ...initState, ...state };
  switch (action.type) {
    case CREATE_DATES:
      return createNewDates(newState, action);
    case SELECT_DATE:
      return selectDate(newState, action);
    default:
      return newState;
  }
};
